//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { TextData, Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogScheduleReassignment from "../../Dialogs/DialogScheduleReassignment/DialogScheduleReassignment";
import DialogUpcomingSchedulesReassignment from "../../Dialogs/DialogUpcomingSchedulesReassignment/DialogUpcomingSchedulesReassignment";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import DialogUpcomingScheduleSuccessfulReassignment from "../../Dialogs/DialogUpcomingScheduleSuccessfulReassignment/DialogUpcomingScheduleSuccessfulReassignment";
import ReservationDurationData from "views/components/Schedules/components/UpdateActivityPopup/components/ReservationDurationData";
//#endregion
//#region Icons
import PhoneIcon from "icons/PhoneIcon";
import MessageIcon from "icons/MessageIcon";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Services
import { 
    requestGetAvailableSchedules, 
    requestGetReasons, 
    requestGetSession, 
    requestGetUpcomingAvailableSchedules } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { LOADING_MESSAGES } from "../constants";
import useMainContext from "utils/context/useMainContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { FieldIconWrapper } from "views/components/Schedules/styles";
import SessionAppointment from "../../ScheduleActivity/SessionAppointment";
//#endregion

const getDateToRequest = date => {
    return date === -1 ? getTodayWithoutHourInMillis() : date;
}

const AppointmentData = ({ 
    title, subtitle, isPresential,
    dateTimeData, changesCannotBeDone,
    reloadData, reservation, 
    showUpdateDialog, isAdviser,
    appointmentId, isTimeAppointment,
    children
}) => {
    const { date, hour } = dateTimeData;
    const mainContext = useMainContext();
    //#region States
    const [dataSchedulesReassignment, setDataSchedulesReassignment] = useState([]);
    const [dataSchedulesUpcomingReassignment, setDataSchedulesUpcomingReassignment] = useState([]);
    const [currentUpcomingSchedule, setCurrentUpcomingSchedule] = useState({});
    const [reasons, setReasons] = useState([]);
    const [session, setSession] = useState(null);
    const [loadingService, setLoadingService] = useState({
        loading: false,
        message: LOADING_MESSAGES.SEARCH
    });
    //#endregion
    const scheduleReassignmentDialog = useShowDialogAlert();
    const noAdvisersForUpcomingSchedulesDialog = useShowDialogAlert();
    const upcomingSchedulesReassignmentDialog = useShowDialogAlert();
    const upcomingScheduleSuccessfulReassignmentDialog = useShowDialogAlert();
    const searchAvisersForUpcomingSchedulesDialog = useShowDialogAlert();

    useEffect(() => {
        handleGetSessionData();
    }, [reservation]);
    const handleGetSessionData = async () => {
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.SEARCH
        };
        setLoadingService({ ...newLoadingService });
        const [reasons, session] = await Promise.all([
            requestGetReasons(),
            requestGetSession(reservation.id)
        ]);

        setReasons(reasons);
        setSession(session);

        setLoadingService({ ...newLoadingService, loading: false });
    }
    //#region Functions
    const searchUpcomingAvailableSchedules = async () => {
        // Ocultando modal de decisión de reasignación con horarios más próximos
        searchAvisersForUpcomingSchedulesDialog.set(false);
        // Habilitando loader
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.SEARCH
        };
        setLoadingService({ ...newLoadingService });
        const fetchDataUpcomingAvailableSchedules = await requestGetUpcomingAvailableSchedules({
            date: getDateToRequest(date),
            timeStart: hour*60,
            appointmentId,
            isPresential
        });
        setLoadingService({ ...newLoadingService, loading: false });
        // Gestión de errores
        if (fetchDataUpcomingAvailableSchedules === null) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        if (fetchDataUpcomingAvailableSchedules.length === 0) {
            noAdvisersForUpcomingSchedulesDialog.set(true);
            return;
        }
        setDataSchedulesUpcomingReassignment(fetchDataUpcomingAvailableSchedules);
        upcomingSchedulesReassignmentDialog.set(true);
    }
    const searchAvailableSchedules = async () => {
        
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.SEARCH
        };
        setLoadingService({ ...newLoadingService });
        const fetchDataScheduleReassignment = await requestGetAvailableSchedules({
            date: getDateToRequest(date),
            timeStart: hour*60,
            appointmentId,
            isPresential
        });
        setLoadingService({ ...newLoadingService, loading: false });
        // Gestión de errores
        if (fetchDataScheduleReassignment === null) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        setDataSchedulesReassignment(fetchDataScheduleReassignment);
        // Verificando si no se encontraron horarios disponibles para esta fecha y hora
        if (fetchDataScheduleReassignment.length === 0) {
            searchAvisersForUpcomingSchedulesDialog.set(true);
            return;
        }
        scheduleReassignmentDialog.set(true);
    }

    //#endregion
    const finalTitle = `${title} (${subtitle})`;
    const duration = {
        date,
        timeParts: {
            start: [hour, 0], 
            end: [hour + 1, 0]
        }
    };

    return (
        <>
        <Column overflowY="auto" padding="40px 0 0" gap="24px">
            <Column gap="8px">
                <Title title={title}>{title}</Title>
                <TextData weight="700">{subtitle}</TextData>
            </Column>
            <Column gap="16px">
                <ReservationDurationData duration={duration}/>
                <Row width="100%" gap="12px" wrap="nowrap">
                    <FieldIconWrapper>
                        <PhoneIcon size={16} />
                    </FieldIconWrapper>
                    <TextData 
                        className="ellipsis" 
                        title={reservation?.phone}>
                        <TextData>{reservation?.phone || "-"}</TextData>
                    </TextData>
                </Row>
                <Row width="100%" gap="12px" wrap="nowrap" align="flex-start">
                    <FieldIconWrapper>
                        <MessageIcon size={16} />
                    </FieldIconWrapper>
                    <TextData 
                        className="wrap"
                        title={reservation?.comment}>
                        {reservation?.comment || "-"}
                    </TextData>
                </Row>
            </Column>
            {isAdviser &&
                <SessionAppointment
                    reservation={reservation}
                    reasons={reasons}
                    session={session}
                    duration={hour}
                />
            }
            {!isAdviser && 
                <CustomButton 
                    text="Reasignar asesoría"
                    disabled={changesCannotBeDone()}
                    width="100%"
                    variant="secondary"
                    onClick={searchAvailableSchedules}/>}
            {children}
        </Column>
        {showUpdateDialog && (
            <>
            <DialogScheduleReassignment 
                show={scheduleReassignmentDialog.value}
                toggleShow={scheduleReassignmentDialog.toggle}
                durationRender={(
                    <ReservationDurationData 
                        duration={duration}
                        gap="8px"
                        color="gray"/>
                )}
                dateTimeData={{ date, hour }}
                isPresential={isPresential}
                reservation={{
                    id: reservation?.id,
                    studentName: title
                }}
                schedules={dataSchedulesReassignment}
                setLoadingService={setLoadingService}
                reloadData={reloadData}/>
            <DialogAlertAction
                minWidth="560px"
                variant="secondary"
                show={searchAvisersForUpcomingSchedulesDialog.value}
                toggleShow={searchAvisersForUpcomingSchedulesDialog.toggle}
                title="No hay asesores disponibles en ese horario"
                content="Busca otro horario o asesor más próximo para la atención.">
                <CustomButton
                    variant="secondary"
                    size="medium"
                    text="Cancelar"
                    width="130px"
                    onClick={searchAvisersForUpcomingSchedulesDialog.hide}/>
                <CustomButton
                    size="medium"
                    text="Buscar Asesor"
                    width="130px"
                    onClick={searchUpcomingAvailableSchedules}/>
            </DialogAlertAction>
            <DialogAlertAction
                variant="secondary"
                width="40%"
                widthContent="95%"
                spacingContainer="25px"
                show={noAdvisersForUpcomingSchedulesDialog.value}
                toggleShow={noAdvisersForUpcomingSchedulesDialog.toggle}
                title="Lo sentimos, no existen asesores disponibles durante los próximos 7 días"
                content="Vuelve a buscar pasado unos días.">
                <CustomButton
                    size="medium"
                    text="Cerrar"
                    width="130px"
                    onClick={noAdvisersForUpcomingSchedulesDialog.hide}/>
            </DialogAlertAction>
            <DialogUpcomingSchedulesReassignment 
                show={upcomingSchedulesReassignmentDialog.value} 
                toggleShow={upcomingSchedulesReassignmentDialog.toggle}
                toggleShowDialogUpcomingSuccessfulReassignment={upcomingScheduleSuccessfulReassignmentDialog.toggle}
                schedules={dataSchedulesUpcomingReassignment}
                currentSchedule={currentUpcomingSchedule}
                setLoadingService={setLoadingService}
                setCurrentUpcomingSchedule={setCurrentUpcomingSchedule}
                isPresential={isPresential}
                reservation={{
                    id: reservation?.id
                }}/>
            <DialogUpcomingScheduleSuccessfulReassignment
                show={upcomingScheduleSuccessfulReassignmentDialog.value}
                toggleShow={upcomingScheduleSuccessfulReassignmentDialog.toggle}
                currentSchedule={currentUpcomingSchedule}
                student={finalTitle}
                reloadData={reloadData}/>
            <Preloader 
                hidden={!loadingService.loading} 
                message={loadingService.message}/>
            </>
        )}
        </>
    );
}


export default AppointmentData;
